import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
   apiKey: "AIzaSyBBhqPig-tw-lTtsBrApbv6SUSNaNGbqH4",
  authDomain: "jardin-d3f24.firebaseapp.com",
  projectId: "jardin-d3f24",
  storageBucket: "jardin-d3f24.firebasestorage.app",
  messagingSenderId: "442397827702",
  appId: "1:442397827702:web:0d35761479e670b416f557",
  measurementId: "G-4V7DNJ361V"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);